import { DataQuery } from '../utils/DataQuery';
import { DataRecord } from '../utils/DataRecord';

import { LogicEngine } from '../LogicEngine/LogicEngine';
import { QueryLogType } from './QueryLogTypes';
import { textChangeRangeIsUnchanged } from 'typescript';

export class QueryLog
{
	log: Partial<QueryLogType> = {};

	constructor(participant_id: string)
	{
		this.log.participant_id = participant_id;
		this.log.event_dt = new Date();
		this.log.event_dt_local = new Date().toISOString();
		this.log.reported_dt = new Date();
		this.log.reported_by = LogicEngine.currentUser;
		this.log.reported_device = LogicEngine.currentDeviceId;
		this.log.reported_ip = LogicEngine.currentIpAddress;
		this.log.message = '';
		this.log.reference_id = '';
		this.log.timezone_offset = new Date().getTimezoneOffset();

		if (LogicEngine.currentSiteId != "")
			this.log.query_site_id = LogicEngine.currentSiteId;
	}

	/** Submit the audit record to the server */
	async save(): Promise<void>
	{
		const record = new DataRecord('Query', this.log);
		record.validateId();
		await record.saveIfNeeded(true);
	}

	/** Set the Query type. Should be one of the static values defined at the bottom
	 * of this file but may be different for some specific use cases with trial
	 * configurations.
	 */
	setQueryType(evType: number | string)
	{
		if (evType === undefined) throw 'Attempt to set QueryLog Query Type to undefined';

		this.log.query_type = evType;
	}

	/** Set a reference to something, may be different depening on use case and audit type */
	setReference(evReference: string)
	{
		this.log.reference_id = evReference;
	}

	/** Set the page name that we are currently looking at
	 * if this is generated from an event on page.
	 */
	setLinkedRoute(routeName: string)
	{
		/* Todo: Convert a route to an array so we can
		see if there is an ID passed */
		this.log.linked_route = routeName;
	}

	/** When changing a table, reference it */
	setTableName(tableName: string, tableId: string, tableField?: string)
	{
		this.log.table_name = tableName;
		this.log.table_field = tableField;
		this.log.reference_id = tableId;
	}

	/* Set Old and New values for audit and change requests
	 ** These should be Formatted values based on a data formatted for the field
	 */
	setMessage(messageText: string)
	{
		this.log.message = messageText;
	}

	setStatus(newStatus: number | string)
	{
		this.log.query_status = newStatus;
	}
	/**
	 * Set Reference Task ID
	 * @param task_id A task ID
	 */
	setReferenceTaskId(task_id: string)
	{
		this.log.reference_task_id = task_id;
	}
}

export namespace QueryLog
{
	export class QueryTypes
	{
		static HumanQuery = '1';
		static SystemQuery = '2';
		static HumanResponse = '51';
		static AutomatedResponse = '52';
		static HumanQueryRecord = '70';
		static SystemQueryRecord = '71';
	}

	export class QueryStatus
	{
		static Open = '1';
		static Answered = '2';
		static Resolved = '3';
		static Deleted = '4';
		static NotResolved = '5';
	}
}
